/**
 * chronology — anno di riferimento per l'ordinamento/collocazione cronologica.
 *
 * Gli autori senza `birth_year` (qui i due anonimi: il Cantar de mio Cid e il
 * Lazarillo) NON devono finire in fondo: pur essendo antichi, vanno collocati
 * per epoca tramite il primo `period`. Usato sia dall'ordinamento del catalogo
 * (StaticDataService) sia dalla timeline della mappa dei temi (ThemeMapView),
 * così l'ordine è coerente ovunque.
 *
 * ⚠️ Le chiavi devono essere i `Period` di questo tool (schema.ts). Restarono
 * a lungo quelle del golden inglese (`victorian`, `modernist`…): nessun period
 * spagnolo corrispondeva, i due anonimi cadevano sul ripiego 1500 e il Cid
 * compariva in mezzo al Rinascimento.
 */

import type { Author } from './schema';

/** Ancora d'epoca (anno medio) per autori privi di `birth_year`. */
export const PERIOD_ANCHOR: Record<string, number> = {
  'edad-media': 1150,
  prerrenacimiento: 1450,
  renacimiento: 1540,
  barroco: 1630,
  ilustracion: 1760,
  romanticismo: 1830,
  'realismo-naturalismo': 1875,
  'fin-de-siglo': 1900,
  vanguardias: 1925,
  posguerra: 1950,
  hispanoamerica: 1955,
  contemporaneo: 1990,
};

/**
 * Anno per ordinare/collocare un autore: `birth_year` se noto, altrimenti
 * l'ancora del primo `period` (fallback 1500 se il period è sconosciuto).
 * `dated` indica se il valore è una data reale o un ripiego d'epoca.
 */
export function chronoYear(author: Author): { year: number; dated: boolean } {
  if (typeof author.birth_year === 'number') return { year: author.birth_year, dated: true };
  const anchor = author.periods[0] ? PERIOD_ANCHOR[author.periods[0]] : undefined;
  return { year: anchor ?? 1500, dated: false };
}
